import { GridOptions, ColDef, GridApi } from "ag-grid-community";
//import { AllModules, ColDef } from '@ag-grid-enterprise/all-modules';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DateService } from '../../../../common/services/date.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { ReportSearchCriteria } from '../../../models/admin-reports.model';
import { AdhocReportsService } from '../../../services/adhoc-reports-service';
import { tap } from 'rxjs/operators';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';

@Component({
    selector: 'app-permit-applications-detailed-report',
    templateUrl: './permit-applications-detailed-report.component.html',
    styleUrls: ['./permit-applications-detailed-report.component.scss'],
    standalone: false
})

export class PermitApplicationsDetailedReportComponent implements OnInit {
  get excelStyles(): any[] {
      if (this.formatService) return this.formatService.excelStyles;
      return [];
  }
    reportData: any[];
    gridOptions: GridOptions;
	gridApi?: GridApi;
    currentDate: Date = new Date();

    get invalidDateCombination(): boolean {
        let invalid: boolean = false;
        if (this.toDate != null && this.fromDate != null) {
            invalid = this.toDate < this.fromDate;
        }
        return invalid;
    }

    toDate: Date | null;
    fromDate: Date | null;

    subHeader: SubHeader= new SubHeader({
        title: "Permitting Applications 3",
        buttons: []
    });

    subscription: Subscription = new Subscription();


  constructor(private datePipe: DatePipe,
    private readonly dateService: DateService,
    private readonly formatService: GridFormatterService,
    private readonly adhocReportService: AdhocReportsService,
    public subHeaderService: SubHeaderService,
	  public dialogService: DynamicDialogService) {
  }

  ngOnInit() {
      this.subHeaderService.updateSubHeader(this.subHeader);
      this.fromDate = this.dateService.generateDateWithOffset(0, -1, 0);
      this.toDate = this.currentDate;
      let coldefs = this.createColumnDefinitions();
      this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
      this.gridOptions.pagination = false;
      this.gridOptions.headerHeight = 50;
      this.gridOptions.suppressColumnVirtualisation = true;
	  this.gridOptions.onGridReady = (params) => {
		  this.gridApi = params.api;
          this.gridApi.sizeColumnsToFit();
	  };
      this.generateReport();
  }

  generateReport() {
      if (this.gridApi) {
          this.gridApi.setGridOption("loading", true);
      }

      const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.fromDate;
      criteria.toDate = this.toDate;

      this.subscription = this.adhocReportService.getPermitApplicationsDetailedReportData(criteria).pipe(
          tap((data) => {
              this.reportData = data;
          })).subscribe({
                next: (success) => {
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("rowData", this.reportData);
                        this.gridApi.setGridOption("loading", false);
                        this.gridApi.sizeColumnsToFit();
                    }
                },    
                error: (fail) => {
                    console.error(fail);
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("loading", false);
                    }
                    this.showError();
                }
      });
  }

  public createColumnDefinitions() {
      return [
            {
                headerClass: "wrapped",
                headerName: "Paper Application",
                headerTooltip: "Paper Application",
                valueFormatter: this.formatStringToYesNo("paperApplication"),
                valueGetter: this.formatStringToYesNo("paperApplication"),
                tooltipValueGetter: this.formatStringToYesNo("paperApplication"),
                minWidth: 135
          },
          {
              headerClass: "wrapped",
              headerName: "Application Status",
              headerTooltip: "Application Status",
              field: "applicationStatus",
              tooltipField: "applicationStatus",
              minWidth: 135
          },
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                tooltipField: "applicationNumber",
                field: "applicationNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 130
          },
          {
              headerClass: "wrapped",
              headerName: "Owner Name",
              headerTooltip: "Owner Name",
              field: "ownerName",
              tooltipField: "ownerName",
              filter: "agTextColumnFilter",
              filterParams: this.formatService.defaultTextFilterParams,
              minWidth: 150
          },
          {
              headerClass: "wrapped",
              headerName: "Well Name",
              headerTooltip: "Well Name",
              field: "wellName",
              tooltipField: "wellName",
              filter: "agTextColumnFilter",
              filterParams: this.formatService.defaultTextFilterParams,
              minWidth: 200
          },
          {
              headerClass: "wrapped",
              headerName: "Well Number",
              headerTooltip: "Well Number",
              field: "wellNumber",
              tooltipField: "wellNumber",
              filter: "agTextColumnFilter",
              filterParams: this.formatService.defaultTextFilterParams,
              minWidth: 150
          },
          {
              headerClass: "wrapped",
              headerName: "API Number",
              headerTooltip: "API Number",
              field: "apiNumber",
              tooltipField: "apiNumber",
              filter: "agTextColumnFilter",
              filterParams: this.formatService.defaultTextFilterParams,
              minWidth: 130,
              cellClass: "stringType"
          },
          {
              headerClass: "wrapped",
              headerName: "Slant",
              headerTooltip: "Slant",
              field: "slant",
              tooltipField: "slant",
              minWidth: 115
          },
          {
              headerClass: "wrapped",
              headerName: "Application Type",
              headerTooltip: "Application Type",
              field: "applicationType",
              tooltipField: "applicationType",
              minWidth: 225
          },
          {
              headerClass: "wrapped",
              headerName: "Proposed Well Type",
              headerTooltip: "Proposed Well Type",
              field: "proposedWellType",
              tooltipField: "proposedWellType",
              filter: "agTextColumnFilter",
              filterParams: this.formatService.defaultTextFilterParams,
              minWidth: 125
          },
          {
              headerClass: "wrapped",
              headerName: "Expedite Permit",
              headerTooltip: "Expedite Permit",
              tooltipValueGetter: this.formatStringToYesNo("expeditePermit"),
              valueFormatter: this.formatStringToYesNo("expeditePermit"),
              valueGetter: this.formatStringToYesNo("expeditePermit"),
              minWidth: 125
          },
          {
              headerClass: "wrapped",
              headerName: "Date Application Received",
              headerTooltip: "Date Application Received",
              field: "dateApplicationReceived",
              filter: "agDateColumnFilter",
              filterParams: this.formatService.defaultDateFilterParams,
              valueFormatter: this.formatService.formatDate('dateApplicationReceived'),
              tooltipValueGetter: this.formatService.formatDate('dateApplicationReceived'),
              minWidth: 135,
              cellClass: "dateType"
          },
          {
              headerClass: "wrapped",
              headerName: "Date Application Approved",
              headerTooltip: "Date Application Approved",
              field: "dateApplicationApproved",
              filter: "agDateColumnFilter",
              filterParams: this.formatService.defaultDateFilterParams,
              valueFormatter: this.formatService.formatDate('dateApplicationApproved'),
              tooltipValueGetter: this.formatService.formatDate('dateApplicationApproved'),
              minWidth: 135,
              cellClass: "dateType"
          },
          {
              headerClass: "wrapped",
              headerName: "Date Issued Permit Expires",
              headerTooltip: "Date Issued Permit Expires",
              field: "dateIssuedPermitExpires",
              filter: "agDateColumnFilter",
              filterParams: this.formatService.defaultDateFilterParams,
              valueFormatter: this.formatService.formatDate('dateIssuedPermitExpires'),
              tooltipValueGetter: this.formatService.formatDate('dateIssuedPermitExpires'),
              minWidth: 140,
              cellClass: "dateType"
          },
          {
              headerClass: "wrapped",
              headerName: "Date Application Denied",
              headerTooltip: "Date Application Denied",
              field: "dateApplicationDenied",
              filter: "agDateColumnFilter",
              filterParams: this.formatService.defaultDateFilterParams,
              valueFormatter: this.formatService.formatDate('dateApplicationDenied'),
              tooltipValueGetter: this.formatService.formatDate('dateApplicationDenied'),
              minWidth: 135,
              cellClass: "dateType"
          },
          {
              headerClass: "wrapped",
              headerName: "Date Application Cancelled",
              headerTooltip: "Date Application Cancelled",
              field: "dateApplicationCancelled",
              filter: "agDateColumnFilter",
              filterParams: this.formatService.defaultDateFilterParams,
              valueFormatter: this.formatService.formatDate('dateApplicationCancelled'),
              tooltipValueGetter: this.formatService.formatDate('dateApplicationCancelled'),
              minWidth: 135,
              cellClass: "dateType"
          },
            {
                headerClass: "wrapped",
                headerName: "Expedite Fee",
                headerTooltip: "Expedite Fee",
                field: "expediteFee",
                tooltipField: "expediteFee",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                tooltipValueGetter: this.formatService.formatCurrency("expediteFee", "USD", "symbol", "1.2-2"),
                valueFormatter: this.formatService.formatCurrency("expediteFee", "USD", "symbol", "1.2-2"),
                minWidth: 115
            },
            {
                headerClass: "wrapped",
                headerName: "Application Fee",
                headerTooltip: "Application Fee",
                field: "applicationFee",
                tooltipField: "applicationFee",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                tooltipValueGetter: this.formatService.formatCurrency("applicationFee", "USD", "symbol", "1.2-2"),
                valueFormatter: this.formatService.formatCurrency("applicationFee", "USD", "symbol", "1.2-2"),
                minWidth: 135
            },
            {
                headerClass: "wrapped",
                headerName: "Pooling Fee",
                headerTooltip: "Pooling Fee",
                field: "poolingFee",
                tooltipField: "poolingFee",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                tooltipValueGetter: this.formatService.formatCurrency("poolingFee", "USD", "symbol", "1.2-2"),
                valueFormatter: this.formatService.formatCurrency("poolingFee", "USD", "symbol", "1.2-2"),
                minWidth: 125
            },
        
         
            
            {
                headerClass: "wrapped",
                headerName: "RICS Owner Number",
                headerTooltip: "RICS Owner Number",
                field: "ricsOwnerNumber",
                tooltipField: "ricsOwnerNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 135
            },
            {
                headerClass: "wrapped",
                headerName: "RBDMS Owner Number",
                headerTooltip: "RBDMS Owner Number",
                field: "rbdmsOwnerNumber",
                tooltipField: "rbdmsOwnerNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 135
            },
          
            {
                headerClass: "wrapped",
                headerName: "County",
                headerTooltip: "County",
                field: "county",
                tooltipField: "county",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 130
            },
            {
                headerClass: "wrapped",
                headerName: "Township",
                headerTooltip: "Township",
                field: "township",
                tooltipField: "township",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 130
            },
            {
                headerClass: "wrapped",
                headerName: "Well Disposition",
                headerTooltip: "Well Disposition",
                field: "wellDisposition",
                tooltipField: "wellDisposition",
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Well Type Description",
                headerTooltip: "Well Type Description",
                field: "wellTypeDescription",
                tooltipField: "wellTypeDescription",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Well Status Description",
                headerTooltip: "Well Status Description",
                field: "wellStatusDescription",
                tooltipField: "wellStatusDescription",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Well Status Reason",
                headerTooltip: "Well Status Reason",
                field: "wellStatusReason",
                tooltipField: "wellStatusReason",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Surface Latitude",
                headerTooltip: "Surface Latitude",
                field: "surfaceLat",
                tooltipField: "surfaceLat",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Surface Longitude",
                headerTooltip: "Surface Longitude",
                field: "surfaceLong",
                tooltipField: "surfaceLong",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Last Take Point Latitude",
                headerTooltip: "Last Take Point Latitude",
                field: "lastTakePtLat",
                tooltipField: "lastTakePtLat",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Last Take Point Longitude",
                headerTooltip: "Last Take Point Longitude",
                field: "lastTakePtLong",
                tooltipField: "lastTakePtLong",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "First Take Point Latitude",
                headerTooltip: "First Take Point Latitude",
                field: "firstTakePtLat",
                tooltipField: "firstTakePtLat",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "First Take Point Longitude",
                headerTooltip: "First Take Point Longitude",
                field: "firstTakePtLong",
                tooltipField: "firstTakePtLong",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Target Latitude",
                headerTooltip: "Target Latitude",
                field: "targetLat",
                tooltipField: "targetLat",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Target Longitude",
                headerTooltip: "Target Longitude",
                field: "targetLong",
                tooltipField: "targetLong",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
          
            {
                headerClass: "wrapped",
                headerName: "Located Urban",
                headerTooltip: "Located Urban",
                tooltipValueGetter: this.formatStringToYesNo("locatedUrban"),
                valueFormatter: this.formatStringToYesNo("locatedUrban"),
                valueGetter: this.formatStringToYesNo("locatedUrban"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Permitted Urban",
                headerTooltip: "Permitted Urban",
                tooltipValueGetter: this.formatStringToYesNo("permittedUrban"),
                valueFormatter: this.formatStringToYesNo("permittedUrban"),
                valueGetter: this.formatStringToYesNo("permittedUrban"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Urbanized Area",
                headerTooltip: "Urbanized Area",
                tooltipValueGetter: this.formatStringToYesNo("urbanizedArea"),
                valueFormatter: this.formatStringToYesNo("urbanizedArea"),
                valueGetter: this.formatStringToYesNo("urbanizedArea"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Urbanized Area Name",
                headerTooltip: "Urbanized Area Name",
                field: "urbanizedAreaName",
                tooltipField: "urbanizedAreaName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Proposed Formations",
                headerTooltip: "Proposed Formations",
                field: "proposedFormations",
                tooltipField: "proposedFormations",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 175
            },
            {
                headerClass: "wrapped",
                headerName: "Producing Formation",
                headerTooltip: "Producing Formation",
                field: "producingFormation",
                tooltipField: "producingFormation",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 200
            },
            {
                headerClass: "wrapped",
                headerName: "Marcellus Shale",
                headerTooltip: "Marcellus Shale",
                tooltipValueGetter: this.formatStringToYesNo("marcellusShale"),
                valueFormatter: this.formatStringToYesNo("marcellusShale"),
                valueGetter: this.formatStringToYesNo("marcellusShale"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Utica Shale",
                headerTooltip: "Utica Shale",
                tooltipValueGetter: this.formatStringToYesNo("uticaShale"),
                valueFormatter: this.formatStringToYesNo("uticaShale"),
                valueGetter: this.formatStringToYesNo("uticaShale"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Point Pleasant",
                headerTooltip: "Point Pleasant",
                tooltipValueGetter: this.formatStringToYesNo("pointPleasant"),
                valueFormatter: this.formatStringToYesNo("pointPleasant"),
                valueGetter: this.formatStringToYesNo("pointPleasant"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Tract Size Less Than Five Acres",
                headerTooltip: "Tract Size Less Than Five Acres",
                tooltipValueGetter: this.formatStringToYesNo("tractSizeLessThanFiveAcres"),
                valueFormatter: this.formatStringToYesNo("tractSizeLessThanFiveAcres"),
                valueGetter: this.formatStringToYesNo("tractSizeLessThanFiveAcres"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Release of Leases Provided",
                headerTooltip: "Release of Leases Provided",
                tooltipValueGetter: this.formatStringToYesNo("releaseOfLeasesProvided"),
                valueFormatter: this.formatStringToYesNo("releaseOfLeasesProvided"),
                valueGetter: this.formatStringToYesNo("releaseOfLeasesProvided"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Gas Storage Well Indicator",
                headerTooltip: "Gas Storage Well Indicator",
                tooltipValueGetter: this.formatStringToYesNo("gasStorageWellIndicator"),
                valueFormatter: this.formatStringToYesNo("gasStorageWellIndicator"),
                valueGetter: this.formatStringToYesNo("gasStorageWellIndicator"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Permitted Total Depth",
                headerTooltip: "Permitted Total Depth",
                field: "permittedTotalDepth",
                tooltipField: "permittedTotalDepth",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Water Shed",
                headerTooltip: "Water Shed",
                field: "waterShed",
                tooltipField: "waterShed",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "RUMA",
                headerTooltip: "RUMA",
                tooltipValueGetter: this.formatStringToYesNo("ruma"),
                valueFormatter: this.formatStringToYesNo("ruma"),
                valueGetter: this.formatStringToYesNo("ruma"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Non Agreement Affidavit",
                headerTooltip: "Non Agreement Affidavit",
                tooltipValueGetter: this.formatStringToYesNo("nonAgreementAffidavit"),
                valueFormatter: this.formatStringToYesNo("nonAgreementAffidavit"),
                valueGetter: this.formatStringToYesNo("nonAgreementAffidavit"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Part of Unitization",
                headerTooltip: "Part of Unitization",
                tooltipValueGetter: this.formatStringToYesNo("partOfUnitization"),
                valueFormatter: this.formatStringToYesNo("partOfUnitization"),
                valueGetter: this.formatStringToYesNo("partOfUnitization"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Unitization Number",
                headerTooltip: "Unitization Number",
                field: "unitizationNumber",
                tooltipField: "unitizationNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Mandatory Pooling",
                headerTooltip: "Mandatory Pooling",
                tooltipValueGetter: this.formatStringToYesNo("mandatoryPooling"),
                valueFormatter: this.formatStringToYesNo("mandatoryPooling"),
                valueGetter: this.formatStringToYesNo("mandatoryPooling"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "State of Ohio Surface Property",
                headerTooltip: "State of Ohio Surface Property",
                tooltipValueGetter: this.formatStringToYesNo("stateOfOhioSurfaceProperty"),
                valueFormatter: this.formatStringToYesNo("stateOfOhioSurfaceProperty"),
                valueGetter: this.formatStringToYesNo("stateOfOhioSurfaceProperty"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "State of Ohio Royalty",
                headerTooltip: "State of Ohio Royalty",
                tooltipValueGetter: this.formatStringToYesNo("stateOfOhioRoyalty"),
                valueFormatter: this.formatStringToYesNo("stateOfOhioRoyalty"),
                valueGetter: this.formatStringToYesNo("stateOfOhioRoyalty"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Pressure Maintenance Well",
                headerTooltip: "Pressure Maintenance Well",
                tooltipValueGetter: this.formatStringToYesNo("pressureMaintenanceWell"),
                valueFormatter: this.formatStringToYesNo("pressureMaintenanceWell"),
                valueGetter: this.formatStringToYesNo("pressureMaintenanceWell"),
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "County Inspector",
                headerTooltip: "County Inspector",
                field: "countyInspector",
                tooltipField: "countyInspector",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "County Regional Supervisor",
                headerTooltip: "County Regional Supervisor",
                field: "countyRegionalSupervisor",
                tooltipField: "countyRegionalSupervisor",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Emergency Contact Name",
                headerTooltip: "Emergency Contact Name",
                field: "emergencyContactName",
                tooltipField: "emergencyContactName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Emergency Contact Phone",
                headerTooltip: "Emergency Contact Phone",
                field: "emergencyContactPhone",
                tooltipField: "emergencyContactPhone",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Emergency Contact Email",
                headerTooltip: "Emergency Contact Email",
                field: "emergencyContactEmail",
                tooltipField: "emergencyContactEmail",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Injection Zone",
                headerTooltip: "Injection Zone",
                field: "injectionZone",
                tooltipField: "injectionZone",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Injection Top Depth",
                headerTooltip: "Injection Top Depth",
                field: "injectionTopDepth",
                tooltipField: "injectionTopDepth",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Injection Bottom Depth",
                headerTooltip: "Injection Bottom Depth",
                field: "injectionBottomDepth",
                tooltipField: "injectionBottomDepth",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Maximum Pressure",
                headerTooltip: "Maximum Pressure",
                field: "maximumPressure",
                tooltipField: "maximumPressure",
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 150
            }
      ] as ColDef[];
  }

  downloadReport() {
      const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.fromDate;
      criteria.toDate = this.toDate;
      let fileName = "PermittingApplications3";
      if (this.fromDate && this.toDate) {
        const fromDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
        const toDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
        fileName = `PermittingApplications3_${fromDate}_${toDate}`;
      }
      
      const sheetName = "Permitting Applications 3";
      this.formatService.exportDataToExcel(fileName, sheetName, this.gridApi);
  }

  fromDateChanged(model: Date): void {
      this.fromDate = model;
  }

  toDateChanged(model: Date): void {
      this.toDate = model;
  }

  resizeColumns(): void {
      if (this.gridOptions && this.gridApi) {
          this.gridApi.sizeColumnsToFit();
      }
  }

  public formatStringToYesNo(column: string): any {
      return (obj: any) => {
          if (obj.data) {
              if (obj.data[column] === "Y") {
                return "Yes";
              }
              return "No";
          }
      }
  }

  showError(): void {
      this.errorDialog.toggleDialog(true);
      this.dialogService.updateDialog(this.errorDialog);
  }

  errorDialog: Dialog = new Dialog("An error has occurred.", [new DialogButton("OK", false, () => { return; })]);

}
